import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Roboto|Bebas+Neue');
`;

const font = {
  header: "'itc-avant-garde-gothic-pro', sans-serif",
  body: "'futura', sans-serif",
};

const colors = {
  red: "#fd5855",
  lightRed: `#E04000`,
  darkRed: "#a01000",
  white: "#FFFFFF",
  black: "#000000",
  lightGrey: "#f0f0f0",
  lightGrey2: "#dedede",
  grey: "#c4c4c4",
  darkGrey: "#333",
  darkGrey2: "#9a9a9a",
  green: "#17c58f",
  blue: "#509ebc",
  darkBlue: "#40465a",
  darkBlueLighter: "#4e566d",
  lightBlue: "#67cff7",
};

const theme = {
  color: {
    primary: {
      main: "#e12726",
      highlight: "#f3a8a8",
    },
    secondary: {
      main: "#535CA5",
    },
    text: {
      primary: "#000",
      secondary: "#565656",
      headline: "#6A73BC",
      light: "#fff",
    },
    background: {
      light: "#fff",
      contentBreaker: "#F3F3F3",
    },
  },
};
export { GlobalStyle, font, colors, theme };
